import downloadBlob from "./downloadBlob";

export default async function downloadResponse(response: Response) {
    let blob = await response.blob();

    downloadBlob(blob, getFileNameByContentDisposition(response.headers.get("content-disposition")!), {
        type: response.headers.get("content-type")!,
    });
}

function getFileNameByContentDisposition(contentDisposition: string) {
    if (!contentDisposition) return "download.xlsx";

    // RFC 5987 (filename*)
    const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8Match && utf8Match[1]) {
        return decodeURIComponent(utf8Match[1]);
    }

    // Regular filename=
    const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
    if (filenameMatch && filenameMatch[1]) {
        return filenameMatch[1];
    }

    return "download.xlsx";
}


// WEBPACK FOOTER //
// ./ClientApp/utils/downloadResponse.ts